class CompanyAbortController {
	private static instance: CompanyAbortController;
	private currentCompanyId: string | null = null;
	private abortControllers: Map<string, AbortController> = new Map();

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	private constructor() {}

	static getInstance(): CompanyAbortController {
		if (!CompanyAbortController.instance) {
			CompanyAbortController.instance = new CompanyAbortController();
		}
		return CompanyAbortController.instance;
	}

	// Method to change company and abort all previous requests
	changeCompany(newCompanyId: string): void {
		if (this.currentCompanyId && this.currentCompanyId !== newCompanyId) {
			// Abort all ongoing requests for the previous company
			this.abortAllRequests(
				`Company changed from ${this.currentCompanyId} to ${newCompanyId}`
			);
		}

		this.currentCompanyId = newCompanyId;
		console.log(`Company changed to: ${newCompanyId}`);
	}

	// // Create a new abort controller for a specific request type
	// createController(requestKey: string): AbortController {
	// 	// Abort existing controller for this request type if it exists
	// 	if (this.abortControllers.has(requestKey)) {
	// 		this.abortControllers.get(requestKey)?.abort();
	// 	}

	// 	const controller = new AbortController();
	// 	this.abortControllers.set(requestKey, controller);
	// 	return controller;
	// }

	private requestSequence: Map<string, number> = new Map();

	createController(requestKey: string): {
		controller: AbortController;
		requestId: number;
	} {
		const currentSequence = (this.requestSequence.get(requestKey) || 0) + 1;
		this.requestSequence.set(requestKey, currentSequence);

		if (this.abortControllers.has(requestKey)) {
			this.abortControllers.get(requestKey)?.abort();
		}

		const controller = new AbortController();
		this.abortControllers.set(requestKey, controller);

		return { controller, requestId: currentSequence };
	}

	isLatestRequest(requestKey: string, requestId: number): boolean {
		return this.requestSequence.get(requestKey) === requestId;
	}

	// Abort specific request
	abortRequest(requestKey: string, reason?: string): void {
		const controller = this.abortControllers.get(requestKey);
		if (controller) {
			controller.abort();
			this.abortControllers.delete(requestKey);
			console.log(`Request ${requestKey} aborted: ${reason || 'Manual abort'}`);
		}
	}

	// Abort all ongoing requests
	abortAllRequests(reason?: string): void {
		this.abortControllers.forEach((controller, key) => {
			controller.abort();
			console.log(`Request ${key} aborted: ${reason || 'Abort all requests'}`);
		});
		this.abortControllers.clear();
	}

	// Clean up completed requests
	cleanupRequest(requestKey: string): void {
		this.abortControllers.delete(requestKey);
	}

	getCurrentCompanyId(): string | null {
		return this.currentCompanyId;
	}
}

export const companyAbortController = CompanyAbortController.getInstance();
